(function () {
    'use strict';

    angular.module("imApp").factory("orderHeadChoiceService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 3745,
                    parameters: parms || {}
                });
            },
            listRelatedChoices: function (parms) {
                return $ihttp.post({
                    method: 3746,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 3747,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
